export enum PitchRejectReason {
  TooFar = 'too_far',
  OldEmployer = 'old_employer',
  BadImage = 'bad_image',
  NoOtherEmployer = 'no_other_employer',
  ConditionsNotMet = 'conditions_not_met',
  DesiredPositionNotAvailable = 'desired_position_not_available',
  Other = 'other',
}
